import { useMemo, useState } from 'react';

export default function useSearchable(options: any[], searchable: boolean) {
  const [keywords, setKeywords] = useState('');

  const filteredOptions = useMemo<any[]>(() => {
    if (!Array.isArray(options) || !options.length) return [];
    if (!searchable) return options;
    if (!keywords?.trim()) return options;
    const keywordsLowerCase = keywords?.toLowerCase() || '';
    // eslint-disable-next-line arrow-body-style
    return options.filter((option) => {
      return !!option?.text?.toLowerCase()?.includes(keywordsLowerCase);
    });
  }, [searchable, options, keywords]);

  const handleKeywordsChange = (payload?: string) => {
    if (!searchable) return;
    setKeywords(payload || '');
  };

  const clearKeywords = () => {
    setKeywords('');
  };

  return { keywords, filteredOptions, onKeywordsChange: handleKeywordsChange, clearKeywords };
}
